import {
  NgModule,
  Optional,
  SkipSelf,
  ErrorHandler,
  APP_INITIALIZER,
} from "@angular/core";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

// Prevent re-import of the core module
import { throwIfAlreadyLoaded } from "./module-import-guard";

// Interceptors
import { TokenInterceptor } from "./interceptors/token.interceptor";
import { SpinnerInterceptor } from "./interceptors/spinner.interceptor";

// Handlers
import { GlobalErrorHandler } from "./handlers/global-error.handler";

// Calling load to get configuration + translation
import { AppConfig } from "./services/app-config.service";
import { TranslationConfigModule } from "./translation.config.module";
import { TranslateService } from "@ngx-translate/core";
export const initResources =
  (config: AppConfig, translate: TranslateService) => () =>
    config.load(translate);

@NgModule({
  exports: [TranslationConfigModule],
  imports: [
    TranslationConfigModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
  ],
  providers: [
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initResources,
      deps: [AppConfig, TranslateService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GlobalErrorHandler,
      multi: true,
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, "CoreModule");
  }
}
